import type { History } from 'history';

import { Routes } from '@share/constants';
import type { ICertificatePaymentSuccessState } from '@share/common-types';

interface NavigateToCertificatePaymentSuccessParams {
  history: History;
  accountUsername: string | undefined;
  token: string;
  state: ICertificatePaymentSuccessState;
  isMemberLoggedIn: boolean;
}

export function getAccountUsernameFromPathname(pathname: string): string | undefined {
  return pathname.match(/^\/([^/]+)\/certificates/)?.[1];
}

export function buildPrivateCertificatePaymentSuccessPath(accountUsername: string): string {
  return `/${accountUsername}${Routes.CertificatesPaymentSuccess}`;
}

export function buildPublicCertificatePaymentSuccessPath(
  accountUsername: string | undefined,
  token: string,
): string {
  const successRoute = Routes.PublicCertificatePaymentSuccess.replace(
    ':token',
    encodeURIComponent(token),
  );
  return accountUsername ? `/${accountUsername}${successRoute}` : successRoute;
}

export function navigateToCertificatePaymentSuccess({
  history,
  accountUsername,
  token,
  state,
  isMemberLoggedIn,
}: NavigateToCertificatePaymentSuccessParams): void {
  if (isMemberLoggedIn && accountUsername) {
    history.push(buildPrivateCertificatePaymentSuccessPath(accountUsername), state);
    return;
  }

  const successPath = buildPublicCertificatePaymentSuccessPath(accountUsername, token);
  history.push(successPath, state);
}
